<template>
  <div class="container-login flex flex-col justify-center items-center bg-paleGrey">
    <h2 class="text-2.5xl lg:text-3.5xl font-black color-black text-center">
      {{ $t('reservation_area.enter_reservation_code') }}
    </h2>
    <div class="input-container">
      <v-text-field
        :label="$t('reservation_area.enter_code_here')"
        name="firstName"
        class="code-input"
        v-model="reservationCodeComputed"
        dense
        outlined
        rounded
        background-color="white"
        :append-icon="appendIcon"
        @click:append="appendIconCallback"
        :disabled="loading"
        :rules="rules"
        validate-on-blur
      ></v-text-field>
      <v-btn
        class="next-btn mt-6"
        color="secondary"
        @click="setReservationCode(reservationCodeComputed)"
        :loading="loading"
        rounded
        :disabled="loading"
        >{{ $t('shared.next') }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { RETREIVE_PASSENGERS } from "../../store/reserve-area/action-types";
import {
  GET_RESERVATION_CODE,
  GET_LOADING,
  GET_APPEND_ICON,
  GET_VALID_CODE,
} from "../../store/reserve-area/getter-types";
import { SET_RESERVATION_CODE_ACTION } from "../../store/reserve-area/action-types";
import { codeLength } from "../../store/reserve-area/index";

export default {
  data: () => ({
    rules: [
      (value) => !!value || "",
      (value) =>
        (value || "").length == codeLength ||
        `El código debe contener ${codeLength} caracteres`,
    ],
  }),
  computed: {
    ...mapGetters({
      loading: GET_LOADING,
      appendIcon: GET_APPEND_ICON,
    }),
    reservationCodeComputed: {
      get() {
        return this.$store.getters[GET_RESERVATION_CODE];
      },
      set(value) {
        this.setReservationCode(value);
      },
    },
  },
  methods: {
    ...mapActions({
      setReservationCode: SET_RESERVATION_CODE_ACTION,
    }),
    appendIconCallback() {
      this.setReservationCode("");
    },
  },
  created() {
    const code = router.currentRoute.query.code || null;
    this.setReservationCode(code);
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
$breakpoint: 600px;
.container-login {
  width: 727.1px;
  height: 422px;
  flex: 0 auto;
  margin: 0 auto;
  border-radius: 15px;

  @media(max-width: $breakpoint){
    width: 100%;
    height: 384px;
  }

  .heading-2 {
    font-size: 45px;
    @media(max-width: $breakpoint){
      font-size: 30px;
    }
  }
  .input-container {
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 51px;
    width: 100%;

    .code-input {
      width: 355px;
      height: 45px;
      @media(max-width: $breakpoint){
        width: 90%;
      }
      &::placeholder {
        color: $black !important;
      }
    }

    .next-btn {
      width: 160px;
      height: 45px;

      @media (max-width: $breakpoint) {
        margin-top: 1rem;
      }
    }
  }
  .v-label {
    font-size: 15px !important;
  }
}
</style>
